module.exports = __webpack_public_path__ + "static/media/login.6a775ba8.svg";